@if (config().visible) {
  <h2 [id]="config().attrName" [ngClass]="config().styleClass" [ngStyle]="config().style">{{ config().i18nKey() | ppLabel: config().label }}</h2>
}
